var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.courses.length
    ? _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "general-path-courses",
            class: { mobile: _vm.mobile }
          },
          [
            !_vm.isMathcounts
              ? _c("h3", [_vm._v("Courses covered")])
              : _c(
                  "h3",
                  {
                    staticClass: "is-mathcounts",
                    class: { mobile: _vm.mobile }
                  },
                  [
                    _vm._v("\n      Recommended for\n      "),
                    _c("img", {
                      staticClass: "mathcounts-logo",
                      class: { mobile: _vm.mobile },
                      attrs: {
                        src:
                          "/site_media/version-cebf733092/images/landing/MathcountsLogo.png",
                        alt: "Mathcounts Logo"
                      }
                    })
                  ]
                ),
            _vm._v(" "),
            _vm._l(_vm.courses, function(course) {
              return _c(
                "section",
                {
                  key: course.slug,
                  staticClass: "course",
                  class: { expanded: _vm.courseIsExpanded[course.slug] }
                },
                [
                  _c(
                    "header",
                    {
                      on: {
                        click: function($event) {
                          return _vm.toggleCourse(course.slug)
                        }
                      }
                    },
                    [
                      !_vm.mobile
                        ? _c("BriocheImageTag", {
                            attrs: {
                              src: course.image_url,
                              width: 28,
                              alt: course.name
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h4", [_vm._v(_vm._s(course.name))]),
                      _vm._v(" "),
                      _vm.mobile
                        ? _c(
                            "span",
                            { staticClass: "toggle-course" },
                            [
                              !_vm.courseIsExpanded[course.slug]
                                ? [_vm._v("View topics")]
                                : [_vm._v("Hide topics")]
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "topicListWrapper-" + course.slug,
                      refInFor: true,
                      staticClass: "topic-list-wrapper"
                    },
                    [
                      _c(
                        "ul",
                        {
                          ref: "topicList-" + course.slug,
                          refInFor: true,
                          staticClass: "topic-list unstyled"
                        },
                        _vm._l(course.concepts_include, function(concept) {
                          return _c(
                            "li",
                            { key: concept, attrs: { title: concept } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(concept) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ]
              )
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }